<section class="ads">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <h2 class="section-title text-center">
                    ادارة حملات اعلانات على Google , Facebook
                </h2>
            </div>
            <div class="col-md-12 text-right">
                <p>
                    فعند الحديث عن الحملات الإعلانية على منصات التواصل الإجتماعي، يتصدرهم موقع فيس بوك بلا منازع نظراً لكم المستخدمين الهائل على الشبكة وتنوعهم من حيث الفئات والأعمار. موقع فيس بوك يتميز كذلك بسهولة عملية إدارة الحملات من خلال السياسات الإعلانية المتعددة التي يتيحها، فالموقع يسهل الوصول إلى الفئة المستهدفة بسهولة وبأقل تكلفة .
                </p>
                <p>
                    <b>أما إن كان هدفك هو:</b>
                    ضمان وصول محتوي موقعك أو اعلان منتجك الي نتائج البحث الأولى فى محركات البحث بالمناطق والدول التى تحددها والحصول علي عدد زيارات أكبر بتكلفة أقل لكل زيارة؛
                </p>
                <p>
                    <b>فنرشح لك خدمة ادارة اعلانات جوجل ادورد Google Adword:</b>
                    وجوجل أدوردز واحدة من أكبر وأقدم منصات الإعلانات التي تديرها شركة جوجل. ودائما ماتحقق إعلانات أدوردز الهدف المطلوب منها بكفاءة، من حيث الوصول إلى السوق المستهدف والعملاء المحتملين بسهولة.
                </p>
            </div>
        </div>
    </div>
</section>